import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ThemeVariantType } from '../typings';
import { ICarouselProps } from '../components/carousel/carousel';

export class CarouselOfItemsModel extends ContentItem {
  get itemsCollection(): IKontentItem[] {
    return get(this._config, 'elements.collection_of_items.value', []);
  }

  get headline(): string {
    return get(this._config, 'elements.headline.value', '');
  }

  get id(): string {
    return get(this._config, 'elements.unique_id.value', '');
  }

  get themeVariant(): ThemeVariantType {
    return get(
      this._config,
      'elements.theme_schema__theme_type.value[0].codename',
      ''
    );
  }

  get enableDots(): boolean {
    return JSON.parse(
      get(this._config, 'elements.has_dots.value[0].codename', 'false')
    );
  }
  get withArrow(): boolean {
    return JSON.parse(
      get(this._config, 'elements.has_arrows.value[0].codename', 'false')
    );
  }
  get allowAutoplay(): boolean {
    return JSON.parse(
      get(this._config, 'elements.has_autoplay.value[0].codename', 'false')
    );
  }
  get slidesPerPage(): number {
    return get(this._config, 'elements.slides_per_page.value') || 1;
  }
  get border(): boolean {
    return (
      get(this._config, 'elements.border.value[0].codename', false) === 'true'
    );
  }
  get controlsSize(): boolean {
    return get(
      this._config,
      'elements.controls_size.value[0].codename',
      'false'
    );
  }
  get slidesPerPageMobile(): number {
    return get(this._config, 'elements.slides_per_page_mobile.value', 0);
  }
  get centered(): boolean {
    return (
      get(this._config, 'elements.centered.value[0].codename', false) === 'true'
    );
  }

  public static create(data: ICarouselOfItems): ICarouselProps {
    const {
      itemsCollection,
      headline,
      themeVariant,
      enableDots,
      withArrow,
      allowAutoplay,
      slidesPerPage,
      slidesPerPageMobile,
      centered,
      border,
      controlsSize,
      id
    } = new CarouselOfItemsModel(data);
    return {
      itemsCollection,
      headline,
      themeVariant,
      enableDots,
      withArrow,
      allowAutoplay,
      slidesPerPage,
      slidesPerPageMobile,
      centered,
      border,
      controlsSize,
      id
    };
  }
}
